import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '../../../components/Wrappers/Wrappers.jsx';
import CtaButton from '../../../commons/ctaButton';
import { useStyles } from './heroSection.styles';

const ECAL_WORLD_DESCRIPTION_1 = 'ECAL World is our high-intent consumer discovery hub where millions of active users search for and sync official events directly to their personal calendars.';

const ECAL_WORLD_DESCRIPTION_2 = 'By listing on ECAL World, you tap into an active ecosystem built to expand your reach, acquire new subscribers, and drive direct action.';

const ECAL_WORLD_DESCRIPTION_3 = 'Planning an upcoming launch, major event, or priority campaign? Submit a request for spotlight featured placement to maximise your visibility.';

function HeroSection ({ onManageListing, onRequestFeatured }) {
    const classes = useStyles();

    return (
        <div className={classes.card}>
            <Typography variant={'caption'} weight={'bold'} className={classes.eyebrow}>
                {'MARKETING · ECAL WORLD'}
            </Typography>

            <Typography variant={'h3'} weight={'bold'} className={classes.headline}>
                Let the people who love your brand find you first.
            </Typography>

            <Typography variant={'body1'} className={classes.intro}>
                {ECAL_WORLD_DESCRIPTION_1}
            </Typography>
            <Typography variant={'body1'} className={classes.intro}>
                {ECAL_WORLD_DESCRIPTION_2}
            </Typography>
            <Typography variant={'body1'} className={classes.intro}>
                {ECAL_WORLD_DESCRIPTION_3}
            </Typography>

            <div className={classes.ctaRow}>
                <CtaButton kind={'primary'} accentColor={'#0F1D40'} onClick={onManageListing}>
                    MANAGE MY LISTING
                </CtaButton>
                <CtaButton kind={'secondary'} onClick={onRequestFeatured}>
                    REQUEST TO BE FEATURED
                </CtaButton>
            </div>

            <Typography variant={'caption'} className={classes.note}>
                <span>· Free to list</span>
                <span>· Change your settings anytime</span>
            </Typography>
        </div>
    );
}

HeroSection.propTypes = {
    onManageListing: PropTypes.func,
    onRequestFeatured: PropTypes.func,
};

HeroSection.defaultProps = {
    onManageListing: () => {},
    onRequestFeatured: () => {},
};

export default HeroSection;
